import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

interface FooterPolicy {
  links: { it: string; en: string };
  labelKey: string;
}

@Component({
  selector: 'app-custom-footer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div>
      {{ 'footer.copyright' | translate: { year: currentYear } }}
      <ng-container *ngFor="let policy of policies; let last = last">
        <a [href]="linkFor(policy)"
           target="_blank"
           rel="noopener">
          {{ policy.labelKey | translate }}
        </a>
        <span *ngIf="!last"> - </span>
      </ng-container>
    </div>
  `,
  styles: []
})
export class CustomFooterComponent {
  private readonly translateService = inject(TranslateService);

  readonly currentYear = new Date().getFullYear();
  // PDF serviti da public/documents (gli stessi usati in origine dalla signup della vecchia admin).
  // Cookie e Sito Web puntano ancora a tncid.app, che risponde con la SPA: TNC-820.
  readonly policies: FooterPolicy[] = [
    {
      links: { it: '/documents/privacy.pdf', en: '/documents/informativa_privacy_en_rev.pdf' },
      labelKey: 'footer.links.products'
    },
    {
      links: { it: 'https://www.tncid.app/cookie-policy', en: 'https://www.tncid.app/cookie-policy' },
      labelKey: 'footer.links.cookie'
    },
    {
      links: { it: 'https://www.tncid.app/privacy-policy-website', en: 'https://www.tncid.app/privacy-policy-website' },
      labelKey: 'footer.links.website'
    }
  ];

  linkFor(policy: FooterPolicy): string {
    return this.translateService.currentLang === 'en' ? policy.links.en : policy.links.it;
  }
}
